import Icon from "@mui/icons-material/VolunteerActivism";
import { ProjectInayatList } from "./ProjectInayatList";
import { ProjectInayatCreate } from "./ProjectInayatCreate";
import { ProjectInayatEdit } from "./ProjectInayatEdit";

export default {
  list: ProjectInayatList,
  create: ProjectInayatCreate,
  edit: ProjectInayatEdit,
  icon: Icon,
  label: "Inayat",
  options: { label: "Inayat" },
  name: "projectInayats",
};
